import React, { useState, useEffect } from 'react';
import { COMPANY_NAME, COMPANY_LOCATION, PHONE_NUMBER, PHONE_NUMBER_TEL } from '@utils/constants';

interface HeaderProps {
  onBookNowClick: () => void;
}

const Header: React.FC<HeaderProps> = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50 transition-shadow ${
        isScrolled ? 'shadow-md' : ''
      }`}
    >
      <div className="px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-3">
            <img src="/golfcart_silhouette.png" alt="Logo" className="h-10 w-10" />
            <div>
              <h1 className="text-xl font-bold text-gray-900">{COMPANY_NAME}</h1>
              <p className="text-xs text-gray-500">{COMPANY_LOCATION}</p>
            </div>
          </div>
          <nav className="hidden md:flex items-center space-x-6">
            <a href="#carts" className="text-gray-700 hover:text-sky-600">
              Our Carts
            </a>
            <a href="#pricing" className="text-gray-700 hover:text-sky-600">
              Pricing
            </a>
            <a href="#contact" className="text-gray-700 hover:text-sky-600">
              Contact
            </a>
            <a
              href={PHONE_NUMBER_TEL}
              className="bg-sky-500 text-white px-5 py-2 rounded-lg hover:bg-sky-600"
            >
              {PHONE_NUMBER}
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;